import { cn } from "../../lib/cn";

export interface EmailCellProps {
  email: string;
  className?: string | undefined;
}

export function EmailCell({ email, className }: EmailCellProps) {
  return (
    <a
      href={`mailto:${email}`}
      className={cn(
        "rounded-sm text-body-m-r text-primary hover:underline focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-primary",
        className,
      )}
    >
      {email}
    </a>
  );
}
